import { SingleServiceCenterDto } from "api"
import { useIsDesktop } from "common/MediaQueries"
import { useState } from "react"
import FormErrorState from "reusable/formsComp/FormErrorState"
import FormSuccessState from "reusable/formsComp/FormSuccessState"
import ClassicPopUp from "reusable/popups/ClassicPopUp"
import styled from "styled-components"
import TreatmentForm from "../forms/TreatmentForm"
import PopUpHeaderUi from "./PopUpHeaderUi"
const StyledWrapperForm = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`
const StyledWrapper = styled.div`
  text-align: center;
  overflow: auto;
  margin-top: -15px;
`

type TreatmentPopupProps = {
  onClose: () => void
  open: boolean
  centerData: SingleServiceCenterDto
}

export enum FormStatus {
  Normal = "normal",
  Success = "success",
  Error = "error",
}

const TreatmentPopup = ({ onClose, open, centerData }: TreatmentPopupProps) => {
  const [formStatus, setFormStatus] = useState<FormStatus>(FormStatus.Normal)
  const isDesktop = useIsDesktop()
  return (
    <ClassicPopUp
      open={open}
      onClose={onClose}
      title={
        formStatus === FormStatus.Success ? "קיבלנו את פנייתך" : centerData.name
      }
      padding={isDesktop ? "20px" : "0px"}
    >
      <StyledWrapper>
        {formStatus === FormStatus.Normal && (
          <PopUpHeaderUi centerData={centerData} type="קביעת ביקור" />
        )}
        <StyledWrapperForm>
          {formStatus === FormStatus.Normal && (
            <TreatmentForm
              centerData={centerData}
              setFormStatus={setFormStatus}
            />
          )}
          {formStatus === FormStatus.Error && <FormErrorState />}
          {formStatus === FormStatus.Success && (
            <FormSuccessState
              title=""
              subtitle={`הצוות שלנו ב${centerData.name} יחזור אליך בקרוב לאישור התור במועד שבחרת`}
            />
          )}
        </StyledWrapperForm>
      </StyledWrapper>
    </ClassicPopUp>
  )
}

export default TreatmentPopup
